import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  endOfList: {
    textAlign: 'center',
    padding: '1rem',
    color: '#888',
    fontSize: '0.875rem',
  },

  // Sortable column header
  sortableColumn: {
    display: 'flex',
  },

  // Name filter
  filterContainer: {
    padding: '8px 0 16px',
    width: '280px',
  },

  // Clone Dialog Footer
  cloneDialogFooter: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },

  // Clone Dialog Content
  cloneDialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },

  // Clone Dialog Form
  cloneFormContainer: {
    // Container for the form elements
  },
  cloneFormLabel: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '500',
  },
  cloneFormInput: {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
  },
  cloneFormError: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
  },
  cloneFormDescription: {
    fontSize: '14px',
    color: '#666',
  },
})

export default useStyles
